import { IPricingSectionV2 } from '@/sanity/lib/definitions';
import { IPricingV2Discount } from '@/sanity/templates';
import PricingHeroBlock from './PricingHeroBlock';
import PricingTiersBlock from './PricingTiersBlock';
import PricingComparisonBlock from './PricingComparisonBlock';
import PricingPlatformsBlock from './PricingPlatformsBlock';

/**
 * Full pricing section — composes all four blocks in the default layout.
 * For a partial usage (e.g. only tier cards on another page), import the
 * individual blocks directly from `@/components/pageComponents/pricingSectionV2`.
 */
export default function PricingSectionV2({
  data,
  language,
  discount,
}: {
  data: IPricingSectionV2 | undefined | null;
  language?: string;
  discount?: IPricingV2Discount;
}) {
  if (!data) return null;

  return (
    <section className="relative w-full py-[8rem]">
      <div className="mx-auto flex w-[min(170.5rem,calc(100%-4rem))] lg:w-[min(170.5rem,calc(100%-8rem))] flex-col items-center gap-[6rem]">
        <PricingHeroBlock data={data} language={language} />
        <PricingTiersBlock data={data} language={language} discount={discount} />
        {data.comparison && data.specsCatalog?.length ? (
          <PricingComparisonBlock data={data} language={language} discount={discount} />
        ) : null}
        {data.platformsFooter && (
          <PricingPlatformsBlock data={data.platformsFooter} language={language} />
        )}
      </div>
    </section>
  );
}
